import { render, staticRenderFns } from "./PesquisaAnsiosoParticipar.vue?vue&type=template&id=c9117622&scoped=true"
import script from "./PesquisaAnsiosoParticipar.vue?vue&type=script&lang=js"
export * from "./PesquisaAnsiosoParticipar.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAnsiosoParticipar.vue?vue&type=style&index=0&id=c9117622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9117622",
  null
  
)

export default component.exports